/**
 * Navigable name/id cell for server-backed grids.
 *
 * The shared "click the name to open the record" cell used by the entity
 * list grids (users, customers, site groups, tickets, …). Navigation is
 * scoped to this cell only: a pointer cursor signals it's clickable, and
 * the click is stopped from bubbling so selecting text or clicking any
 * other column never opens the record. Use this for the primary link cell
 * instead of a whole-row onRowClick. Renders a block-level router Link so
 * callers can pass multi-line content (a name plus a description/icon) and
 * extra `sx`; colour the clickable text via a child (e.g. a primary-main
 * Typography), matching the entity-grid house style.
 */
import { Box } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

export default function GridLinkCell({ to, children, onClick, sx, ...rest }) {
  const handleClick = e => {
    // Keep navigation to the link itself — don't trigger a row-level
    // onRowClick (when a grid still uses one) or navigate on a stray
    // cell click / text selection.
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <Box
      component={Link}
      to={to}
      onClick={handleClick}
      sx={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit', ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
}
